import { Cancel, Edit } from "@mui/icons-material";
import { Card, CardActions, Box, Typography, IconButton, Collapse } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";
import { useState } from "react";
import { getDateWithSuffix } from "../../../time/timeUtils";
import { Dayjs, dayjs } from "../../../utils/dayjs-config";

interface DropdownCalendarProps {
    label: string;
    date: Dayjs; 
    onDateChange: (newDate: Dayjs) => void; // Function to handle date changes
    shouldDisableDate?: (date: Dayjs) => boolean; // Optional function to disable specific dates
}

const DropdownCalendar: React.FC<DropdownCalendarProps> = ({
    label,
    date,
    onDateChange,
    shouldDisableDate,
}) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <Card sx={{ mb: 2, borderRadius: '12px', boxShadow: 3 }}>
            <CardActions disableSpacing>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <Typography variant="h6" sx={{ color: "text.primary", textTransform: "uppercase" }}>
                            {label}
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary" }}>
                            {date.format('dddd, ')}{date.format('MMMM')} {getDateWithSuffix(date)}
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={() => setExpanded((prev) => !prev)}
                        aria-expanded={expanded}
                        aria-label={`edit ${label.toLowerCase()}`}
                    >
                        {expanded ? <Cancel /> : <Edit />}
                    </IconButton>
                </Box>
            </CardActions>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <DateCalendar
                    value={date}
                    onChange={(newDate) => onDateChange(dayjs(newDate))}
                    disablePast={true}
                    shouldDisableDate={shouldDisableDate}
                />
            </Collapse>
        </Card>
    );
};

export default DropdownCalendar;
